// @mui
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
// utils

// ----------------------------------------------------------------------

const RenderChangePasswordButton = ({ permission, link }) => {
    const permissionArry = useSelector((state) => state.Login.permissionArry);

    const authorize = permissionArry.includes(permission)
    return (
        <>
            {authorize &&
                <Link to={link} className="edit-password"><i className="ri-lock-2-line"></i></Link>            }

        </>

    );
}
export default (RenderChangePasswordButton);
